export class BatchCheckProcessingModel {
    accrualDate: string | null = null;
    expectDateFrom: string | null = null;
    expectDateTo: string | null = null;
    checkNo: string = '';
    bankName: string = '';
    bankId: number = 0;
    vendorDetails: VendorDetail[] = [];
    checkDetails: CheckDetail[] = [];
}

export class VendorDetail {
    id: number = 0;
    payToId: number = 0;
    billNo: string = '';
    invoiceDate: string | null = null;
    amount: number = 0;
    description: string = '';
    payToName: string = '';
    checkSeq: number = 0;
    issue: string = '';
    select: boolean = false;
    payGLNo: string = '';
    blNo: string = '';
    branch: string = '';
}

export class CheckDetail {
    payToOrderName: string = '';
    checkNo: number = 0;
    amount: number = 0;
    payToOrderId: number = 0;
    billIds: string = '';
}
